export default __webpack_public_path__ + "static/media/Horizontall_HTB.eb9572e2.md";